<template>
    <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
            <div class="md-layout">
                <div class="md-layout-item">
                    <div class="card-icon">
                        <i class="md-icon fas fa-desktop"/>
                    </div>
                    <h4 class="title">{{ report.name }}</h4>
                </div>
            </div>
        </md-card-header>
        <md-card-content>
            <div>
                <div class="md-layout">
                    <div class="md-layout-item md-medium-size-100 md-large-size-50 md-xlarge-size-50">
                        <div class="md-input-radio">
                            <label>Contrôle</label>
                            <div>
                                <md-radio v-model="isControled" :value="true">Oui</md-radio>
                                <md-radio v-model="isControled" :value="false">Non</md-radio>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="isControled">
                    <div class="md-layout mt-2">
                        <div class="md-layout-item md-size-50">
                            <div class="md-multiselect">
                                <label>Tâches effectuées </label>
                                <multiselect
                                    v-model="task"
                                    :options="config.tasks"
                                    :option-height="104"
                                    placeholder=""
                                    track-by="id"
                                    label="label"
                                    :show-labels="false">
                                    <template slot="noOptions">La liste est vide</template>
                                    <template slot="noResult">Aucun élement correspondant</template>
                                </multiselect>
                            </div>
                        </div>
                    </div>
                    <div class="md-layout mt-2">
                        <div class="md-layout-item md-size-50">
                            <div class="md-multiselect">
                                <label>Quantité insectes présents :</label>
                                <multiselect
                                    v-model="quantity"
                                    :options="config.quantities"
                                    :option-height="104"
                                    track-by="id"
                                    label="label"
                                    placeholder=""
                                    :show-labels="false">
                                    <template slot="noOptions">La liste est vide</template>
                                    <template slot="noResult">Aucun élement correspondant</template>
                                </multiselect>
                            </div>
                        </div>
                    </div>
                    <div class="md-layout mt-2">
                        <div class="md-layout-item md-size-50">
                            <div class="md-multiselect">
                                <label> Réapprovisionnement</label>
                                <multiselect
                                    :options="[]"
                                    :option-height="104"
                                    track-by="id"
                                    label="label"
                                    placeholder=""
                                    :show-labels="false">
                                    <template slot="noOptions">La liste est vide</template>
                                    <template slot="noResult">Aucun élement correspondant</template>
                                </multiselect>
                            </div>
                        </div>
                    </div>
                    <div class="md-layout mt-2">
                        <div class="md-layout-item md-size-50">
                            <div class="md-multiselect">
                                <label>Commentaires</label>
                                <multiselect
                                    v-model="comment"
                                    :options="config.comments"
                                    :option-height="104"
                                    label="label"
                                    track-by="id"
                                    placeholder=""
                                    :show-labels="false">
                                    <template slot="noOptions">La liste est vide</template>
                                    <template slot="noResult">Aucun élement correspondant</template>
                                </multiselect>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="md-layout mt-2">
                        <div class="md-layout-item md-size-50">
                            <div class="md-multiselect">
                                <label>Raison</label>
                                <multiselect
                                    v-model="reason"
                                    :options="config.reasons"
                                    :option-height="104"
                                    label="label"
                                    track-by="id"
                                    placeholder=""
                                    :show-labels="false">
                                    <template slot="noOptions">La liste est vide</template>
                                    <template slot="noResult">Aucun élement correspondant</template>
                                </multiselect>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="md-layout mt-2">
                    <div class="md-layout-item md-size-50">
                        <div class="md-multiselect">
                            <label>Changement dispositif</label>
                            <multiselect
                                v-model="deviceType"
                                :options="deviceTypes"
                                :option-height="104"
                                placeholder=""
                                track-by="id"
                                label="name"
                                :show-labels="false">
                                <template slot="noOptions">La liste est vide</template>
                                <template slot="noResult">Aucun élement correspondant</template>
                            </multiselect>
                        </div>
                    </div>
                </div>
                <div class="md-layout mt-2">
                    <div class="md-layout-item md-size-50">
                        <md-field class="md-invalid">
                            <label>Commentaires libres</label>
                            <md-textarea md-autogrow></md-textarea>
                        </md-field>
                    </div>
                </div>
            </div>
        </md-card-content>
        <md-card-actions md-alignment="left">
            <md-button class="md-warning"
                       @click="$router.go(-1)">
                Retour
            </md-button>
        </md-card-actions>
    </md-card>
</template>

<script>
export default {
    name: "EighthReport",
    data() {
        return {
            isControled: true,
            report: {},
            config: {
                comments: [],
                reasons: [],
                tasks: [],
                quantities: [],
            },
            deviceTypes: [],
            reason: null,
            comment: null,
            deviceType: null,
            task: null,
            quantity: null,
        }
    },
    methods: {
        async getReportDetails() {
            let {data} = await this.$store.dispatch('deviceReportTypes/getDeviceReportTypeDetails', this.$route.params.id)
            this.report = {
                ...data.report,
            }
            this.config = {
                ...data.config
            }
        },
        async getDeviceTypes() {
            let {data} = await this.$store.dispatch('devices/getDeviceTypes')
            this.deviceTypes = [
                ...data,
            ]
        }
    },
    mounted() {
        this.getReportDetails();
        this.getDeviceTypes();
    }
}
</script>

<style scoped>

</style>

